import { regionFlagMap } from '@/data/region-flag'
import {
  sponsorshipAudienceAnalyticsSchema,
  type DemographicsRawData,
  type ParsedDemographicsData,
} from '@/schemas/sponsor.schems'

export const parseDemographicsData = (demographicsRaw: DemographicsRawData) => {
  if (!demographicsRaw?.data) return null

  const parsed = sponsorshipAudienceAnalyticsSchema.safeParse(
    demographicsRaw.data
  )
  return parsed.data
}

export const transformGeographicData = (
  demographicsData: ParsedDemographicsData
) => {
  if (!demographicsData) return []

  return demographicsData.geographicDistribution.map(item => ({
    name: item.region,
    users: item.count,
    percentage: item.percentage,
    flag: regionFlagMap[item.region] || regionFlagMap.Other,
  }))
}

export const transformAgeChartData = (
  demographicsData: ParsedDemographicsData
) => {
  if (!demographicsData) return []

  const ageData = demographicsData.ageDistribution
  return Object.keys(ageData)
    .filter(key => key.toLowerCase() !== 'unknown')
    .map(key => ({
      ageRange: key,
      users: ageData[key as keyof typeof ageData],
    }))
}

export const processDemographicsData = (
  demographicsRaw: DemographicsRawData
) => {
  const demographicsData = parseDemographicsData(demographicsRaw)

  return {
    demographicsData,
    geographicList: transformGeographicData(demographicsData),
    ageChartData: transformAgeChartData(demographicsData),
  }
}
